module.exports = __webpack_public_path__ + "img/dextools.f83053e3.jpeg";